module.exports = __webpack_public_path__ + "img/精神状态.4d14623e.png";